import Reveal from "@/components/landing/Reveal";
import { useI18n } from "@/lib/i18n";

export default function HowItWorks() {
  const { t } = useI18n();
  const steps = t("how.steps") || [];
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-emerald-800 dark:text-emerald-400">
              {t("how.kicker")}
            </div>
            <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight text-balance text-neutral-900 dark:text-neutral-50">
              {t("how.h2Pre")}{" "}
              <span className="text-emerald-800 dark:text-emerald-400">
                {t("how.h2Highlight")}
              </span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 relative grid grid-cols-1 md:grid-cols-3 gap-6">
          <div
            aria-hidden
            className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-emerald-800/0 via-emerald-800/30 dark:via-emerald-400/30 to-emerald-800/0"
          />
          {steps.map((s, i) => (
            <Reveal key={s.number} delay={i * 0.08}>
              <div
                data-testid={`step-card-${s.number}`}
                className="relative rounded-3xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 p-7 sm:p-8 h-full"
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-emerald-800 text-stone-50 dark:bg-emerald-400 dark:text-neutral-950 inline-flex items-center justify-center font-display font-bold">
                    {i + 1}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-neutral-500">
                    {t("how.stepLabel")} {s.number}
                  </div>
                </div>
                <h3 className="mt-6 font-display font-semibold text-xl sm:text-2xl text-neutral-900 dark:text-neutral-50">
                  {s.title}
                </h3>
                <p className="mt-3 text-[15px] text-neutral-600 dark:text-neutral-400 leading-relaxed">
                  {s.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
